import { useMemo } from 'react'
import { useIntl } from 'react-intl'

export const ESIM_IMAGE_ID = 'qooj3ldzuulsgukb3ww4'
export const ESIM_HUBBY_COMPATIBLE_PHONES_LINK = 'https://www.hubbyesim.com/compatible-phones'
export const HUBBY_APP_STORE_URL = 'https://apps.apple.com/us/app/hubby-esim/id1671196088'
export const HUBBY_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.hubby.esim&hl=en'
export const HUBBY_QR_IMAGE_ID = 'am3hd5yq0ggdnbnwmrlb'

export function useLoyaltyEsimImage(): App.Image {
  const intl = useIntl()

  return useMemo(() => ({
    id: ESIM_IMAGE_ID,
    title: intl.formatMessage({
      id: 'by1SDGsyDqAt4uWH2673',
      defaultMessage: 'Free travel eSIM for Société members',
      description: 'Accessible image title for the loyalty eSIM benefit artwork used across loyalty benefit surfaces',
    }),
  }), [intl])
}
